import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err: unknown) => {
    if (isMissingUuidDatabaseError(err)) {
      const target = window.location.pathname.startsWith('/patient')
        ? 'patient/login'
        : 'login';
      redirectToAppPath(target);
      return;
    }
    console.error(err);
  });

function isMissingUuidDatabaseError(err: unknown): boolean {
  return err instanceof Error && err.message.includes('AppDatabase requires an authenticated user uuid.');
}

function redirectToAppPath(path: string): void {
  const normalized = path.replace(/^\/+/, '');
  const target = new URL(normalized, document.baseURI);
  window.location.assign(target.toString());
}
